(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("jquery"), require("clone"), require("classnames"), require("js-cookie"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "jquery", "clone", "classnames", "js-cookie"], factory);
	else if(typeof exports === 'object')
		exports["interactive-tutorials"] = factory(require("react"), require("react-dom"), require("jquery"), require("clone"), require("classnames"), require("js-cookie"));
	else
		root["interactive-tutorials"] = factory(root["react"], root["react-dom"], root["jquery"], root["clone"], root["classnames"], root["js-cookie"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paragraphs = exports.abortTutorial = exports.startTutorial = exports.registerFinaliseCallback = exports.registerTutorials = undefined;

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _reactDom = __webpack_require__(2);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	var _jquery = __webpack_require__(3);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _clone = __webpack_require__(4);

	var _clone2 = _interopRequireDefault(_clone);

	var _tutorial = __webpack_require__(5);

	var _tutorial2 = _interopRequireDefault(_tutorial);

	var _utils = __webpack_require__(9);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var TUTORIAL_CLASS = null;
	var REGISTER_DELAY = null;
	var TUTORIALS = {};

	function init_dom(callback) {
	  if (TUTORIAL_CLASS !== null) {
	    callback();
	    return;
	  }
	  var destination = (0, _jquery2.default)('<div>');
	  destination.appendTo('body');
	  TUTORIAL_CLASS = _reactDom2.default.render(_react2.default.createElement(_tutorial2.default, null), destination[0]);
	  callback();
	}

	function register_tutorials() {
	  init_dom(function () {
	    TUTORIAL_CLASS.updateTutorials(TUTORIALS);
	  });
	}

	function registerTutorials(tutorials) {
	  var newTutorials = (0, _clone2.default)(TUTORIALS);
	  for (var tutorialKey in tutorials) {
	    newTutorials[tutorialKey] = tutorials[tutorialKey];
	  }TUTORIALS = newTutorials;
	  if (REGISTER_DELAY !== null) window.clearTimeout(REGISTER_DELAY);
	  REGISTER_DELAY = window.setTimeout(register_tutorials, 500);
	}

	function registerFinaliseCallback(callback) {
	  init_dom(function () {
	    TUTORIAL_CLASS.addFinaliseCallback(callback);
	  });
	}

	function startTutorial(tutorialKey) {
	  if (TUTORIAL_CLASS === null) {
	    console.error('Cannot start tutorial: Tutorials not yet initialised.');
	    return;
	  }
	  TUTORIAL_CLASS.start(tutorialKey);
	}

	function abortTutorial() {
	  if (TUTORIAL_CLASS === null) {
	    console.warning('Cannot abort tutorial: Tutorials not yet initialised.');
	    return;
	  }
	  TUTORIAL_CLASS.abort();
	}

	exports.registerTutorials = registerTutorials;
	exports.registerFinaliseCallback = registerFinaliseCallback;
	exports.startTutorial = startTutorial;
	exports.abortTutorial = abortTutorial;
	exports.paragraphs = _utils.paragraphs;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = require("react");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = require("react-dom");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = require("jquery");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = require("clone");

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _jquery = __webpack_require__(3);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _reactDom = __webpack_require__(2);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	var _classnames = __webpack_require__(6);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _clone = __webpack_require__(4);

	var _clone2 = _interopRequireDefault(_clone);

	var _jsCookie = __webpack_require__(7);

	var _jsCookie2 = _interopRequireDefault(_jsCookie);

	var _conditions = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var BASE_Z_INDEX = 1050;

	function clear_step_checkpoints(tutorial) {
	  for (var stepIndex = 0; stepIndex < tutorial.steps.length; stepIndex++) {
	    var step = tutorial.steps[stepIndex];
	    _jsCookie2.default.remove('tutorial_' + tutorial.key + '_' + step.key);
	  }
	  if (tutorial.checkpoints) {
	    for (var checkpointIndex = 0; checkpointIndex < tutorial.checkpoints.length; checkpointIndex++) {
	      var checkpoint = tutorial.checkpoints[checkpointIndex];
	      _jsCookie2.default.remove('tutorial_' + tutorial.key + '_' + checkpoint.checkpoint);
	    }
	  }
	}

	function set_step_checkpoint(tutorial, step) {
	  _jsCookie2.default.set('tutorial_' + tutorial.key + '_' + step.key, true, { path: '/' });
	}

	var Tutorial = function (_React$Component) {
	  _inherits(Tutorial, _React$Component);

	  function Tutorial(props) {
	    _classCallCheck(this, Tutorial);

	    var _this = _possibleConstructorReturn(this, (Tutorial.__proto__ || Object.getPrototypeOf(Tutorial)).call(this, props));

	    _this.state = _extends({}, _this.state, {

	      tutorials: {},
	      finaliseCallbacks: [],

	      popupActive: false,
	      blockingInput: false,

	      tutorial: null,
	      complete: false,
	      step: null,

	      tooHigh: true,
	      tooLow: false
	    });
	    return _this;
	  }

	  _createClass(Tutorial, [{
	    key: 'addFinaliseCallback',
	    value: function addFinaliseCallback(callback) {
	      this.setState(function (state) {
	        state.finaliseCallbacks = state.finaliseCallbacks.concat(callback);
	        return state;
	      });
	    }
	  }, {
	    key: 'updateTutorials',
	    value: function updateTutorials(tutorials) {
	      this.setState(function (state) {
	        state.tutorials = tutorials;
	        return state;
	      }, this.refreshStep);
	    }
	  }, {
	    key: 'refreshStep',
	    value: function refreshStep(callback) {
	      if (this.state.tutorial !== null) {
	        if (this.state.tutorial.complete && this.state.tutorial.complete.on == 'checkpointReached') {
	          if (_jsCookie2.default.get('tutorial_' + this.state.tutorial.key + '_' + this.state.tutorial.complete.checkpoint)) {
	            _jsCookie2.default.set('tutorial_complete_' + this.state.tutorial.key, true, { path: '/' });
	          }
	        }

	        if (_jsCookie2.default.get('tutorial_complete_' + this.state.tutorial.key)) {
	          this.setState(function (state) {
	            state.step = null;
	            state.complete = true;
	            state.popupActive = true;
	            return state;
	          });
	          return;
	        }
	      }

	      var newStep = null;
	      var oldStepIndex;
	      var newStepIndex;
	      if (this.state.tutorial !== null) {
	        for (var stepIndex = this.state.tutorial.steps.length - 1; stepIndex >= 0; stepIndex--) {
	          var step = this.state.tutorial.steps[stepIndex];

	          if (this.state.step !== null && step.key == this.state.step.key) oldStepIndex = stepIndex;

	          var met = (0, _conditions.conditionsMet)(step.activeWhen, true);
	          if (newStep === null && met) {
	            newStep = step;
	            newStepIndex = stepIndex;
	          }
	        }
	      }

	      if (newStep === null) {
	        if (this.state.step !== null) {
	          this.setState(function (state) {
	            state.step = null;
	            state.complete = false;
	            return state;
	          }, function () {
	            if (typeof callback == 'function') callback();
	            this.refreshOffPage();
	          });
	        }
	      } else {
	        if (this.state.step === null || newStep.key != this.state.step.key) {
	          this.setState(function (state) {
	            state.step = newStep;
	            state.complete = false;
	            if (oldStepIndex === null || newStepIndex > oldStepIndex) state.popupActive = true;
	            return state;
	          }, function () {
	            if (typeof callback == 'function') callback();
	            this.refreshOffPage();
	          });
	        }
	      }
	    }
	  }, {
	    key: 'refreshOffPage',
	    value: function refreshOffPage() {
	      if (this.state.step !== null) {
	        var highlight = (0, _jquery2.default)(this.state.step.highlight);
	        if (highlight && typeof highlight[0] !== 'undefined') {
	          var rect = highlight[0].getBoundingClientRect();
	          if (rect.bottom < 0) {
	            if (this.state.tooHigh == true || this.state.tooLow == false) {
	              this.setState(function (state) {
	                state.tooHigh = false;
	                state.tooLow = true;
	                return state;
	              });
	            }
	            return;
	          }
	          if (rect.top > window.outerHeight) {
	            if (this.state.tooHigh == false || this.state.tooLow == true) {
	              this.setState(function (state) {
	                state.tooHigh = true;
	                state.tooLow = false;
	                return state;
	              });
	            }
	            return;
	          }
	        }
	      }
	      if (this.state.tooHigh != false || this.state.tooLow != false) {
	        this.setState(function (state) {
	          state.tooHigh = false;
	          state.tooLow = false;
	          return state;
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;

	      (0, _jquery2.default)(document).on('shown.bs.dropdown', this.refreshStep.bind(this));
	      (0, _jquery2.default)(document).on('hidden.bs.dropdown', this.refreshStep.bind(this));
	      // hide the tutorial when navigating to a link, already completed steps may show for the load time
	      (0, _jquery2.default)(document).on('click', 'a[href]:not([href=""]):not([href="#"])', function (event) {
	        _this2.close();
	      });
	      var onInputChange = function onInputChange(event, ignoreBlank) {
	        var newValue = (0, _jquery2.default)(event.target).val();
	        if (_this2.proceedAfter !== null) {
	          window.clearTimeout(_this2.proceedAfter);
	          _this2.proceedAfter = null;
	        }
	        if (newValue == '' && ignoreBlank) return;
	        if (_this2.state.tutorial !== null && !_this2.state.step.editWhileOpen) _this2.acknowledge(null);
	        _this2.proceedAfter = window.setTimeout(function () {
	          _this2.refreshStep();
	        }, 1500);
	      };
	      onInputChange = onInputChange.bind(this);
	      (0, _jquery2.default)(document).on('shown.bs.modal', function () {
	        _this2.acknowledge(null);
	      });
	      (0, _jquery2.default)(document).on('single-page-tab-loaded', function (event) {
	        window.setTimeout(function () {
	          _this2.refreshStep();
	        }, 500);
	      });
	      (0, _jquery2.default)(document).on('input', 'input, textarea', function (event) {
	        onInputChange(event, true);
	      });
	      (0, _jquery2.default)(document).on('change', 'select', function (event) {
	        onInputChange(event, true);
	      });
	      (0, _jquery2.default)(document).on('change', 'input[type="radio"]', function (event) {
	        onInputChange(event, false);
	      });
	      (0, _jquery2.default)(document).on('selectChoice', function (event) {
	        onInputChange(event, false);
	      });
	      (0, _jquery2.default)(document).on('submit', 'form', function (event) {
	        if (!_this2.state.tutorial) return;

	        var expect_form = function expect_form(form, method, url, callback) {
	          if (method && form.attr('method') != method) return false;
	          if (url && form.attr('action').match(url) === null) return false;
	          callback();
	          return true;
	        };
	        expect_form = expect_form.bind(_this2);

	        var form = (0, _jquery2.default)(event.target);
	        if (_this2.state.tutorial.complete && _this2.state.tutorial.complete.on == 'form_submission') {
	          expect_form(form, _this2.state.tutorial.complete.form.method, _this2.state.tutorial.complete.form.url, function () {
	            _jsCookie2.default.set('tutorial_complete_' + _this2.state.tutorial.key, true, { path: '/' });
	          });
	        }
	        if (!_this2.state.tutorial.checkpoints) return;
	        for (var checkpointIndex = 0; checkpointIndex < _this2.state.tutorial.checkpoints.length; checkpointIndex++) {
	          var checkpoint = _this2.state.tutorial.checkpoints[checkpointIndex];
	          if (checkpoint.on != 'form_submission') continue;
	          expect_form(form, checkpoint.form.method, checkpoint.form.url, function () {
	            _jsCookie2.default.set('tutorial_' + _this2.state.tutorial.key + '_' + checkpoint.checkpoint, true, { path: '/' });
	          });
	        }
	      });
	      window.setInterval(this.refreshOffPage.bind(this), 500);
	      window.setTimeout(function () {
	        var tutorialKey = _jsCookie2.default.get('tutorial_active');
	        if (tutorialKey) {
	          _this2.setState(function (state) {
	            state.tutorial = (0, _clone2.default)(state.tutorials[tutorialKey]);
	            state.step = null;
	            return state;
	          }, function () {
	            _this2.refreshStep(_this2.open.bind(_this2));
	          });
	        }
	      }, 500);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this3 = this;

	      if (!prevState.popupActive && this.state.popupActive) {
	        if (this.state.step !== null && this.state.step.highlight) {
	          var highlight = (0, _jquery2.default)(this.state.step.highlight);
	          if (!this.state.step.noFocus) {
	            if (highlight.is('input') || highlight.is('select')) highlight.focus();else {
	              highlight.find('input, select').first().focus();
	            }
	          }
	        }
	        this.setState(function (state) {
	          state.blockingInput = true;
	          return state;
	        });
	      }
	      if (prevState.popupActive && !this.state.popupActive) {
	        window.setTimeout(function () {
	          if (!_this3.state.popupActive) {
	            _this3.setState(function (state) {
	              state.blockingInput = false;
	              return state;
	            });
	          }
	        }, 600);
	      }
	    }
	  }, {
	    key: 'start',
	    value: function start(tutorialName) {
	      var _this4 = this;

	      var tutorial = this.state.tutorials[tutorialName];
	      if (!tutorial) {
	        console.error('Tutorial "' + tutorialName + '" not found.');
	        return;
	      }
	      _jsCookie2.default.set('tutorial_active', tutorialName, { path: '/' });
	      clear_step_checkpoints(tutorial);
	      this.setState(function (state) {
	        state.tutorial = (0, _clone2.default)(tutorial);
	        state.step = null;
	        state.popupActive = true;
	        return state;
	      }, function () {
	        _this4.refreshStep();
	      });
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      if (this.state.tutorial !== null) {
	        this.setState(function (state) {
	          state.popupActive = true;
	          return state;
	        });
	      }
	    }
	  }, {
	    key: 'dismissAnnouncement',
	    value: function dismissAnnouncement(event) {
	      this.acknowledge(300);
	    }
	  }, {
	    key: 'acknowledge',
	    value: function acknowledge(delay) {
	      var _this5 = this;

	      if (this.state.tutorial === null) return;
	      set_step_checkpoint(this.state.tutorial, this.state.step);
	      this.close();
	      if (delay !== null) {
	        window.setTimeout(function () {
	          _this5.refreshStep();
	        }, delay);
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (this.state.popupActive && !this.state.complete) {
	        this.setState(function (state) {
	          state.popupActive = false;
	          return state;
	        });
	      }
	    }
	  }, {
	    key: 'finalise',
	    value: function finalise() {
	      this.abort();
	      for (var callbackIndex = 0; callbackIndex < this.state.finaliseCallbacks.length; callbackIndex++) {
	        var callback = this.state.finaliseCallbacks[callbackIndex];
	        callback(this.state.tutorial);
	      }
	    }
	  }, {
	    key: 'abort',
	    value: function abort() {
	      _jsCookie2.default.remove('tutorial_active');
	      if (this.state.tutorial !== null) {
	        _jsCookie2.default.remove('tutorial_complete_' + this.state.tutorial.key);
	        this.setState(function (state) {
	          state.tutorial = null;
	          state.step = null;
	          state.complete = false;
	          state.popupActive = false;
	          return state;
	        });
	      }
	    }
	  }, {
	    key: 'exit',
	    value: function exit() {
	      if (this.state.complete) return;
	      this.abort();
	    }
	  }, {
	    key: 'renderHighlightStyles',
	    value: function renderHighlightStyles() {
	      var styles = '';
	      if (this.state.popupActive) {
	        if (this.state.step !== null) {
	          if (this.state.step.highlight) {
	            var background = '';
	            if (this.state.step.highlightBack) {
	              background = 'background: ' + this.state.step.highlightBack + ';\n';
	            }

	            styles += '\n' + this.state.step.highlight + ' {\n  position: relative;\n  z-index: ' + (BASE_Z_INDEX + 2) + ';\n  ' + background + '\n}\n          ';
	          }
	        }
	      }
	      return styles;
	    }
	  }, {
	    key: 'renderAnnotationStyles',
	    value: function renderAnnotationStyles() {
	      var step = this.state.step;
	      var styles = '';
	      if (this.state.popupActive) {
	        if (step !== null) {
	          if (step.annotate) {
	            var margin,
	                position,
	                movement,
	                selector,
	                addSelector = '';
	            if (step.annotateAfter) {
	              margin = 'margin-top: 1rem;\n';
	              position = 'position: absolute;\n';
	              movement = 'top: 100%;\n';

	              selector = step.annotateAfter;
	              addSelector = step.annotateAfter + ':after';
	            } else if (step.annotateBefore) {
	              margin = 'margin-bottom: 1rem;\n';
	              position = 'position: absolute;\n';
	              movement = 'bottom: 100%;\n';

	              selector = step.annotateBefore;
	              addSelector = step.annotateBefore + ':before';
	            } else if (step.annotateIn) {
	              margin = 'margin-top: 1rem;\n';
	              position = 'position: absolute;\n';

	              selector = step.annotateIn;
	              addSelector = step.annotateIn + ':after';
	            }

	            if (selector) {
	              var content = step.annotate || '';
	              if (step.annotateSkip) {
	                if (step.editWhileOpen) {
	                  content += '\n\nWhen you are done, press the \'' + step.annotateSkip + '\' button in the bottom right corner of your screen.';
	                } else {
	                  content += '\n\nTo continue, press the \'' + step.annotateSkip + '\' button in the bottom right corner of your screen.';
	                }
	              }
	              content = content.replace(/\n/g, '\\00000a').replace(/'/g, "\\'");
	              styles += '\n' + addSelector + ' {\n  opacity: 0.9;\n  content: \'' + content + '\';\n  ' + margin + '\n  ' + position + '\n  ' + movement + '\n  left: 0;\n  width: 100%;\n  min-width: 200px;\n  max-width: 500px;\n  z-index: ' + (BASE_Z_INDEX + 2) + ';\n  color: #fff;\n  white-space: pre-wrap;\n  font-size: 15px;\n  line-height: 1.2em;\n  text-align: left;\n}\n          ';
	            }
	            if (step.annotateBefore || step.annotateAfter) {
	              styles += '\n' + selector + ' {\n  position: relative;\n}\n            ';
	            }
	          }
	        }
	      }
	      return styles;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;

	      var current;
	      if (this.state.tutorial !== null) {
	        var steps = [];
	        var activeFound = false;
	        for (var stepIndex = 0; stepIndex < this.state.tutorial.steps.length; stepIndex++) {
	          var step = this.state.tutorial.steps[stepIndex];
	          var active = this.state.step !== null && step.key == this.state.step.key;

	          if (active) activeFound = true;

	          var icon;
	          if (active) {
	            steps.push(_react2.default.createElement(
	              'li',
	              { key: step.key, className: 'active' },
	              '\u25CF'
	            ));
	          } else if (!activeFound) {
	            steps.push(_react2.default.createElement(
	              'li',
	              { key: step.key, className: 'complete' },
	              '\u25CF'
	            ));
	          } else {
	            steps.push(_react2.default.createElement(
	              'li',
	              { key: step.key, className: 'future' },
	              '\u25CB'
	            ));
	          }
	        }
	        var actions = [];
	        actions.push(_react2.default.createElement(
	          'a',
	          {
	            key: 'abort',
	            className: 'btn btn-primary btn-md float-xs-left',
	            onClick: this.exit.bind(this),
	            disabled: this.state.complete
	          },
	          'Exit Tutorial'
	        ));
	        if (this.state.blockingInput) {
	          actions.push(_react2.default.createElement(
	            'a',
	            {
	              key: 'hide',
	              href: '#',
	              className: 'btn btn-secondary btn-md float-xs-right',
	              onClick: function onClick(event) {
	                event.preventDefault();
	                _this6.close();
	              },
	              disabled: !this.state.popupActive || this.state.complete
	            },
	            'Hide Help'
	          ));
	        } else {
	          actions.push(_react2.default.createElement(
	            'a',
	            {
	              key: 'open',
	              href: '#',
	              className: 'btn btn-secondary btn-md float-xs-right',
	              onClick: function onClick(event) {
	                event.preventDefault();
	                _this6.open();
	              },
	              disabled: this.state.complete
	            },
	            'Show Help'
	          ));
	        }
	        current = _react2.default.createElement(
	          'div',
	          { className: 'status' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            this.state.tutorial.title
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'steps' },
	            steps
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'actions' },
	            actions
	          )
	        );
	      }

	      var complete;
	      if (this.state.complete) {
	        complete = _react2.default.createElement(
	          'div',
	          { className: 'complete' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            this.state.tutorial.complete.title || 'Tutorial Complete'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            this.state.tutorial.complete.message
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'btn btn-primary float-xs-right', onClick: this.finalise.bind(this) },
	            'Complete'
	          )
	        );
	      }

	      var skipper;
	      if (this.state.step !== null && this.state.step.annotateSkip) {
	        skipper = _react2.default.createElement(
	          'div',
	          { className: 'skipper' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { className: 'btn btn-primary btn-block', href: '#', onClick: function onClick(event) {
	                  event.preventDefault();
	                  _this6.dismissAnnouncement();
	                } },
	              this.state.step.annotateSkip
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '(Go to next step)'
	          )
	        );
	      }

	      var announcement;
	      if (this.state.popupActive && this.state.step !== null && this.state.step.announce) {
	        var dismiss;
	        if (this.state.step.announceDismiss) {
	          dismiss = _react2.default.createElement(
	            'a',
	            {
	              className: 'float-xs-right btn btn-secondary',
	              href: '#',
	              onClick: function onClick(event) {
	                event.preventDefault();
	              }
	            },
	            this.state.step.announceDismiss
	          );
	        }
	        announcement = _react2.default.createElement(
	          'div',
	          { className: 'announcement' },
	          this.state.step.announce.trim(),
	          _react2.default.createElement(
	            'div',
	            { className: 'dismiss', onClick: this.dismissAnnouncement.bind(this) },
	            dismiss
	          )
	        );
	      }
	      var blackoutSize = 0;
	      if (this.state.blockingInput) blackoutSize = 100;
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('react-tutorial-container', { 'active': this.state.popupActive }) },
	        _react2.default.createElement(
	          'style',
	          null,
	          this.renderHighlightStyles() + '\n' + this.renderAnnotationStyles()
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('blackout', {
	              'too-high': this.state.tooHigh,
	              'too-low': this.state.tooLow
	            }),
	            style: {
	              width: blackoutSize + '%',
	              height: blackoutSize + '%'
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'too-low' },
	            '\u2191 Scroll up to see the next section of the tutorial \u2191'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'too-high' },
	            '\u2193 Scroll down to see the next section of the tutorial \u2193'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'announcements',
	            style: {
	              width: blackoutSize + '%',
	              height: blackoutSize + '%'
	            }
	          },
	          announcement
	        ),
	        current,
	        complete,
	        skipper
	      );
	    }
	  }]);

	  return Tutorial;
	}(_react2.default.Component);

	exports.default = Tutorial;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = require("classnames");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = require("js-cookie");

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.conditionsMet = undefined;

	var _jquery = __webpack_require__(3);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _jsCookie = __webpack_require__(7);

	var _jsCookie2 = _interopRequireDefault(_jsCookie);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function conditionsMet(conditions, mustMatchAll) {
	  var anyConditionMet = false;
	  var allConditionsMet = true;
	  for (var conditionIndex = 0; conditionIndex < conditions.length; conditionIndex++) {
	    var condition = conditions[conditionIndex];
	    var conditionMet = false;
	    switch (condition.compare) {
	      case 'url':
	        if (window.location.pathname.match(condition.url) !== null) conditionMet = true;
	        break;

	      case 'inputVal':
	        var input = (0, _jquery2.default)(condition.selector);
	        if (input) {
	          if (input.is('input[type="radio"]')) {
	            if (input.prop('checked') == condition.value) conditionMet = true;
	          } else {
	            if (input.val() == condition.value) conditionMet = true;
	          }
	        }

	        break;

	      case 'inputNotVal':
	        var input = (0, _jquery2.default)(condition.selector);
	        if (input) {
	          if (input.is('input[type="radio"]')) {
	            if (input.prop('checked') != condition.value) conditionMet = true;
	          } else {
	            if (input.val() != condition.value) conditionMet = true;
	          }
	        }
	        break;

	      case 'dropdownState':
	        var dropdown = (0, _jquery2.default)(condition.selector);
	        if (dropdown.length == 1) {
	          var state;
	          if (dropdown.hasClass('open')) state = 'open';else state = 'closed';
	          if (state == condition.state) conditionMet = true;
	        }
	        break;

	      case 'checkpointComplete':
	        if (_jsCookie2.default.get('tutorial_' + condition.checkpoint)) conditionMet = true;
	        break;

	      case 'checkpointIncomplete':
	        if (!_jsCookie2.default.get('tutorial_' + condition.checkpoint)) conditionMet = true;
	        break;

	      case 'either':
	        if (conditionsMet(condition.when, false)) conditionMet = true;
	        break;

	      case 'all':
	        if (conditionsMet(condition.when, true)) conditionMet = true;
	        break;
	    }

	    if (conditionMet) {
	      anyConditionMet = true;
	      if (!mustMatchAll) return true;
	    } else {
	      allConditionsMet = false;
	    }
	  }
	  if (!mustMatchAll) return false;else {
	    return allConditionsMet;
	  }
	};

	exports.conditionsMet = conditionsMet;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function paragraphs(strings) {
	  var lines = strings[0].split(/(?:\r\n|\n|\r)/);
	  return lines.map(function (line) {
	    var trimmed = line.replace(/^\s+/gm, '');
	    if (trimmed == '') {
	      return '\n\n';
	    } else {
	      return trimmed;
	    }
	  }).join(' ').replace(/\n[\ ]+/g, '\n').trim();
	};

	exports.paragraphs = paragraphs;

/***/ })
/******/ ])
});
;